import React, { Component } from 'react';
import DataStore from '../../../stores/DataStore';
/**
 * @class
 * Zur Anzeige von TextFields
 * @name Geometry
 * @implements {Attribute}
 */
class Geometry extends Component {
  constructor(params) {
    super(params);
  }

  onChange(evt) {
    const { attribute: { onChange, value = '' } = {} } = this.props;
    onChange(evt);
  }

  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    const { value = '' } = DataStore.attributeValues[this.id];
    return JSON.stringify(value);
  }

  getSummaryDisplay() {
    return <div>{this.getValueString()}</div>;
  }

  render() {
    const {
      attribute: {
        id = '',
        name = '',
        attributeOption: {
          //   Field= TextField,
          //   InputProps={},
        },
        attributeModul,
      } = {},
    } = this.props;
    attributeModul.holdedAttribute = this;
    this.id = id;
    return (
      // <div />
      <DataStore.geo.GeometryPicker
        symbol="default"
        disabled={DataStore.attributeValues[this.id].readOnly}
        type="point"
        label="SomeLabel"
        map={DataStore.map}
        onChange={(geo) => this.onChange(geo)}
      />
    );
  }
}

// {
//     symbol = 'default',
//     disabled = false,
//     value,
//     onChange = (geo) => {
//       /* do sth with value */ console.warn(
//         'Value changed to ',
//         geo,
//         'you should overwrite this function!',
//       );
//     },
//     type = 'point' /* || 'polyline' || 'polygon' */,
//     label = '',
//     InputProps,
//     formatDisplayValue = (geo) => {
//       return geo
//         ? `${JSON.stringify(geo)}`
//         : 'Bitte wählen Sie eine Geometrie aus';
//     },
//     onError,
//     variant,
//     map,

export default Geometry;
